export default {
  data() {
    return {
      //属性表数据
      tableAttributeData: [],
      //配置对应的属性id
      configAttributeId: '',
      configAttributeName: '',
      //属性值表数据
      ConfigTableData: [],

      search: '',
      dialogFormVisible: false,
      dialogFormVisible2: false,
      //详情弹窗状态
      dialogFormRead: false,
      //属性编辑弹窗状态
      dialogEditVisible: false,
      //配置弹窗状态
      dialogFormConfig: false,
      //编辑属性值弹窗状态
      dialogEditConfig: false,
      //搜索栏属性名
      attribute_name: '',
      //增加属性绑定数据
      form: {
        attributeName: ''
      },
      //配置属性绑定数据
      Configform: {
        name: '',
        sort: ''
      },
      //编辑属性绑定数据
      Editform: {
        attributeId: '',
        attributeName: '',
        attribute_values: [{ attribute_value_id: '', attribute_value_name: '' }]
      },
      //编辑属性值绑定数据
      ConfigEditform: {
        id: '',
        name: '',
        sort: ''
      },
      //属性详情绑定数据
      dec: {
        attributeName: '',
        attribute_values: []
      },
      formLabelWidth: '120px',

      // 分页
      totalProduct: 1,
      productLen: 15,
      offset: 0,
      totalPage: '',
      // 当前页
      currentPage: 1,
      // 默认初始显示条数
      length: 999,
    }


  },
  methods: {
    // handleEdit(index, row) {
    //   // console.log(index, row);
    // },
    //分页每页条数
    // handleSizeChange(val) {
    //   // // console.log(`每页 ${val} 条`);
    //   this.productLen = val;
    //   this.getAttributeData();
    // },
    handleSizeChange (val) {
      this.length = val
      this.getAttributeData()
    },
    //分页开始条数
    // handleCurrentChange(val) {
    //   // // console.log(`当前页: ${val}`);
    //   this.offset = (val - 1) * this.productLen
    //   this.getAttributeData();
    // },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getAttributeData()
    },
    //搜索按钮事件
    onSearch() {
      let data = {
        token: this.$store.state.authority_management,
        offset: 0,
        // id: this.keywordId,
        name: this.keywordName,
        length: this.productLen
      };
      // 这里调用搜索资源接口
      this.$post('', data).then(res => {
        // // console.log(res)
        //this.tableAttributeData = res.data.result.data
        //this.totalProduct = res.data.result.total
      })
    },
    //配置按钮事件
    configValue(id, name) {
      this.dialogFormConfig = true;
      this.configAttributeId = id;
      this.configAttributeName = name;
      this.getAttribute_value(id, name);

    },
    //配置属性值
    addConfig() {
      if (!this.checkConfig()) {

      }
      else {
        this.addConfig_value();
        // // console.log(this.configAttributeId)

      }
    },
    //编辑属性值按钮事件
    ConfigEdit(attribute_value_id, attribute_value_name, attribute_value_sort) {
      this.dialogEditConfig = true;
      this.ConfigEditform.id = attribute_value_id;
      this.ConfigEditform.name = attribute_value_name;
      this.ConfigEditform.sort = attribute_value_sort;

    },
    //编辑属性值
    EditAttributeValue() {
      if (!this.checkAttributeValue()) {

      } else {
        this.changeAttributeValue();
        this.dialogEditConfig = false;
      }

    },
    //更改属性值
    changeAttributeValue() {
      let data = {
        sort: this.ConfigEditform.sort,
        name: this.ConfigEditform.name,
        id: this.ConfigEditform.id,
        token: this.$store.state.authority_management
      }
      this.$post('attribute_value/shop_edit', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            type: 'success',
            message: '修改成功'
          });
          //修改成功后请求刷新数据
          this.getAttribute_value(this.configAttributeId, this.configAttributeName);

        } else {
          this.$message({
            type: 'error',
            message: '修改失败'
          });
        }

      })
    },
    //校验属性值的编辑
    checkAttributeValue() {
      if (this.ConfigEditform.name == '') {
        this.$message({
          showClose: true,
          message: '属性值名称不能为空',
          type: 'warning'
        });
        return false;
      }
      else if (this.ConfigEditform.sort == '') {
        this.$message({
          showClose: true,
          message: '属性值排序不能为空',
          type: 'warning'
        });
        return false;
      }
      else if (isNaN(this.ConfigEditform.sort)) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '属性值排序必须为数字'
        });
        return false;
      }
      else {
        return true;
      }
    },
    //校验属性值的添加
    checkConfig() {
      if (this.Configform.name == '') {
        this.$message({
          showClose: true,
          message: '属性值名称不能为空',
          type: 'warning'
        });
        return false;
      }
      else if (this.Configform.sort == '') {
        this.$message({
          showClose: true,
          message: '属性值排序不能为空',
          type: 'warning'
        });
        return false;
      }
      else if (isNaN(this.Configform.sort)) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '属性值排序必须为数字'
        });
        return false;
      }
      else {
        return true;
      }
    },
    //添加属性值
    addConfig_value() {
      let data = {
        attribute_value_name: this.Configform.name,
        attribute_value_sort: this.Configform.sort,
        shop_id: this.$store.state.store.id,
        attribute_id: this.configAttributeId,
        token: this.$store.state.authority_management
      }
      this.$post('attribute_value/shop_create_value', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            type: 'success',
            message: '添加成功'
          });
          //添加成功后请求刷新数据
          this.getAttribute_value(this.configAttributeId, this.configAttributeName);
        } else {
          this.$message({
            type: 'error',
            message: '添加失败'
          });
        }
        this.Configform.name = '';
        this.Configform.sort = '';

      })
    },
    //配置属性值的删除按钮事件
    handleConfigDelete(id) {
      this.$confirm('此操作将永久删除该属性值, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.ConfigDelete(id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除属性值
    ConfigDelete(id) {
      let data = {
        token: this.$store.state.authority_management,
        id: id
      }
      // // console.log('属性值' + id);
      this.$post('attribute_value/shop_delete', data).then(res => {
        if (res.data.status == 'success') {
          // // console.log('属性值' + id);
          this.$post('attribute_value_type/shop_delete', data).then(res2 => {
            if (res.data.status == 'success') {
              this.$message({
                type: 'success',
                message: '删除成功'
              });
              //添加成功后请求刷新数据
              this.getAttribute_value(this.configAttributeId, this.configAttributeName);
            }
            else {
              this.$message({
                type: 'error',
                message: '删除失败'
              });
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '删除失败'
          });
        }
      })
    },
    //获取属性值
    getAttribute_value(id, name) {
      let data = {
        offset: 0,
        length: 999,
        id: id,
        shop_id: this.$store.state.store.id,
        name: name,
        token: this.$store.state.authority_management
      }
      this.$post('attribute/search', data).then(res => {

        // // console.log(res.data.result.data[0].attribute_value_type);
        this.ConfigTableData = res.data.result.data[0].attribute_value_type;
      })
    },
    //属性表删除按钮事件
    handleAttributeDelete(id) {
      this.$confirm('此操作将永久删除该属性, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmAttributeDelete(id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //编辑按钮事件
    edit(id, name) {
      this.dialogEditVisible = true;
      this.Editform.attributeId = id;
      this.Editform.attributeName = name;
      let data = {
        offset: 0,
        length: 999,
        id: id,
        shop_id: this.$store.state.store.id,
        name: name,
        token: this.$store.state.authority_management
      }
      this.$post('attribute/search', data).then(res => {

        //this.dec.attribute_values = res.data.result.data;
        this.Editform.attribute_values = res.data.result.data[0].attribute_value_type;
      })
    },
    //编辑属性
    EditAttribute() {
      if (this.Editform.attributeName == '') {
        this.$message({
          showClose: true,
          message: '属性名不能为空',
          type: 'warning'
        });
      }
      else {
        let data = {
          name: this.Editform.attributeName,
          id: this.Editform.attributeId,
          token: this.$store.state.authority_management
        }
        this.$post('attribute/shop_edit', data).then(res => {
          if (res.data.status === 'success') {
            this.$message({
              showClose: true,
              message: '编辑成功',
              type: 'success'
            });
            //更新数据
            this.getAttributeData();
          }
          else {
            this.$message({
              showClose: true,
              message: '编辑失败',
              type: 'error'
            });
          }
        })
        this.dialogEditVisible = false;

      }
    },
    //详情按钮事件
    read(id, name) {
      this.dialogFormRead = true;
      this.dec.attributeName = name;
      let data = {
        offset: 0,
        length: 999,
        id: id,
        shop_id: this.$store.state.store.id,
        name: name,
        token: this.$store.state.authority_management
      }
      this.$post('attribute/search', data).then(res => {
        //this.dec.attribute_values = res.data.result.data;
        this.dec.attribute_values = res.data.result.data[0].attribute_value_type;
        // // console.log(res.data.result.data[0].attribute_value_type);
      })
    },
    //获取属性
    getAttributeData() {
      let data = {
        offset: (this.currentPage - 1) * this.length,
        length: this.length,
        shop_id: this.$store.state.store.id,
        token: this.$store.state.authority_management
      }
      this.$post('attribute/shop_search', data).then(res => {
        this.totalProduct = res.data.result.total;
        this.tableAttributeData = res.data.result.data;
        // // console.log(res.data.result);
      })

    },
    // 添加属性
    addAttribute() {
      if (this.form.attributeName == '') {
        this.$message({
          showClose: true,
          message: '属性名不能为空',
          type: 'error'
        });
      }
      else {
        let data = {
          name: this.form.attributeName,
          shop_id: this.$store.state.store.id,
          token: this.$store.state.authority_management,
        }
        this.$post('attribute/shop_create', data).then(res => {
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '添加成功'
            })
            // 添加成功后请求刷新数据
            this.getAttributeData();
            this.dialogFormVisible = false
          }
        })
      }
    },
    //删除属性
    confirmAttributeDelete(id) {
      let data = {
        token: this.$store.state.authority_management,
        id: id
      }
      this.$post('attribute/shop_delete', data).then(res => {
        if (res.data.status == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          //删除成功后请求刷新数据
          this.getAttributeData();
        } else {
          this.$message({
            type: 'error',
            message: '删除失败'
          });
        }
      })

    }
  },
  created() {
    this.getAttributeData();
  }
}